/** Per-field visibility for metadata shown on lobby game row cards. */
export type LobbyCardMetadataOptions = {
  contest_name: boolean;
  sport: boolean;
  prize_pool: boolean;
  entries: boolean;
  start_time: boolean;
  /** Dark bottom gradient over the tile image for metadata legibility. */
  gradient_overlay: boolean;
};

export const LOBBY_CARD_METADATA_FIELDS: Array<{
  key: keyof LobbyCardMetadataOptions;
  label: string;
}> = [
  { key: 'contest_name', label: 'Contest name' },
  { key: 'sport', label: 'Sport' },
  { key: 'prize_pool', label: 'Prize pool' },
  { key: 'entries', label: 'Entries' },
  { key: 'start_time', label: 'Start time / lock time' },
];

export const DEFAULT_LOBBY_CARD_METADATA_OPTIONS: LobbyCardMetadataOptions = {
  contest_name: true,
  sport: true,
  prize_pool: true,
  entries: true,
  start_time: true,
  gradient_overlay: true,
};

function readBool(value: unknown, fallback: boolean): boolean {
  return typeof value === 'boolean' ? value : fallback;
}

/** Normalize metadata toggles from section payload; defaults all fields to on. */
export function normalizeLobbyCardMetadataOptions(
  payload: Record<string, unknown> | undefined
): LobbyCardMetadataOptions {
  const raw = payload?.metadata_options;
  if (!raw || typeof raw !== 'object') {
    return { ...DEFAULT_LOBBY_CARD_METADATA_OPTIONS };
  }

  const options = raw as Record<string, unknown>;
  return {
    contest_name: readBool(options.contest_name, true),
    sport: readBool(options.sport, true),
    prize_pool: readBool(options.prize_pool, true),
    entries: readBool(options.entries, true),
    start_time: readBool(options.start_time, true),
    gradient_overlay: readBool(options.gradient_overlay, true),
  };
}

export function hasVisibleLobbyCardMetadata(options: LobbyCardMetadataOptions): boolean {
  return (
    options.contest_name ||
    options.sport ||
    options.prize_pool ||
    options.entries ||
    options.start_time
  );
}
